import React, { ReactNode } from "react"
import { classNames } from "../../utils/classNames"

export interface IButtonProps extends React.ComponentPropsWithoutRef<"button"> {
  children: ReactNode
  variant?: "primary" | "secondary" | "outline" | "danger"
}

const variantToClasses = (variant: IButtonProps["variant"]): string => {
  switch (variant) {
    case "secondary":
      return "btn-secondary"
    case "outline":
      return "btn-outline"
    case "danger":
      return "btn-danger"
    default:
      return "btn"
  }
}

export const Button = ({ children, variant, className = "", ...rest }: IButtonProps) => {
  return (
    <button className={classNames(variantToClasses(variant), className)} {...rest}>
      {children}
    </button>
  )
}
